{
  "version": 1,
  "asset_id": "fdd6d709-cdb2-466a-b832-44ada6597fe0",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/fdd6d709-cdb2-466a-b832-44ada6597fe0/pavimento-cotto-cortile-trattato-lombardia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/fdd6d709-cdb2-466a-b832-44ada6597fe0/pavimento-cotto-cortile-trattato-lombardia.webp",
  "original_filename": "pavimento-cotto-cortile-trattato-lombardia.webp",
  "size": 103924,
  "content_type": "image/webp",
  "created_at": "2026-09-02T15:12:14Z"
}
